import styled from 'styled-components';

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  width: 100%;
`;

export const PanelTitle = styled.div`
  flex: 1;
  min-width: 0;
  color: #24324b;
  font-weight: 600;
  line-height: 1.45;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const PackageRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
  border: 1px solid #edf1f5;
  border-radius: 14px;
  background: #fff;
  transition: all 0.2s ease;

  &:hover {
    border-color: #dbe7f3;
    box-shadow: 0 4px 14px rgba(15, 23, 42, 0.05);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
    align-items: stretch;
    gap: 10px;
    padding: 12px;
  }
`;

export const PackageNameWrap = styled.div`
  min-width: 0;
`;

export const PackageName = styled.div`
  color: #24324b;
  font-weight: 500;
  line-height: 1.5;
  font-size: 14px;
  @media (max-width: 576px) {
    font-size: 14px;
  }
`;

export const PackageActionWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;

  @media (max-width: 576px) {
    justify-content: flex-start;
    width: 100%;
  }
`;

export const QtyControl = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 8px;
  border-radius: 999px;
  min-width: 132px;
  justify-content: center;
  flex: 0 0 auto;

  @media (max-width: 576px) {
    min-width: auto;
    padding: 0;
    gap: 8px;
    justify-content: flex-start;
  }
`;

export const QtyButton = styled.button`
  width: 34px;
  height: 34px;
  border: 1px solid #d7e2ee;
  border-radius: 10px;
  background: #ffffff;
  color: #344054;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  flex: 0 0 auto;

  &:hover:not(:disabled) {
    border-color: #98aee0;
    background: #f5f8ff;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;
    color: #b7c2cf;
    background: #f2f4f7;
    border-color: #e4e7ec;
    box-shadow: none;
  }

  @media (max-width: 576px) {
    width: 32px;
    height: 32px;
  }
`;

export const QtyValue = styled.div`
  min-width: 28px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #1d2939;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;

export const HeaderCount = styled.div<{ $isReached?: boolean }>`
  font-size: 12px;
  font-weight: 600;
  color: ${({ $isReached }) => ($isReached ? '#ff4d4f' : '#667085')};
  background: ${({ $isReached }) => ($isReached ? '#fff1f0' : '#f8fafc')};
  border: 1px solid ${({ $isReached }) => ($isReached ? '#ffccc7' : '#e6edf5')};
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
`;

export const SectionNote = styled.div`
  color: #ff4d4f;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
`;

export const InfoButton = styled.button`
  width: 32px;
  height: 32px;
  border: 1px solid #d8efe9;
  border-radius: 999px;
  background: #f4fffc;
  color: #00b3a6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 0 0 auto;

  &:hover:not(:disabled) {
    background: #e9fffa;
    border-color: #8ee3d4;
    transform: translateY(-1px);
  }

  &:disabled {
    cursor: default;
    opacity: 0.45;
    background: #f8fafc;
    border-color: #e5e7eb;
    color: #98a2b3;
  }
`;

export const PopoverContent = styled.div`
  max-width: 360px;

  @media (max-width: 576px) {
    max-width: calc(100vw - 48px);
  }
`;

export const PopoverTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #24324b;
  line-height: 1.45;
  margin-bottom: 8px;
`;

export const PopoverDesc = styled.div`
  font-size: 13px;
  color: #475467;
  line-height: 1.65;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: anywhere;
`;
export const PackageNote = styled.div`
  margin-top: 4px;
  color: #ff4d4f;
  font-size: 13px;
  font-style: italic;
  line-height: 1.45;
  word-break: break-word;
  overflow-wrap: anywhere;
`;
export const PackageTextBlock = styled.div`
  min-width: 0;
`;
